import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
class HeaderPrimaryMenu {
  private header!: HTMLElement | null;
  private desktopWidth = 1025;
  private menuItems!: NodeListOf<HTMLAnchorElement>;
  private backButton!: HTMLElement | null;
  private closeButton!: HTMLElement | null;
  private overlay!: HTMLElement | null;
  private submenus!: NodeListOf<HTMLElement>;
  private primaryLinks!: NodeListOf<HTMLElement>;
  private linksMobile!: NodeListOf<HTMLElement>;
  private primaryMenu!: NodeListOf<HTMLElement>;

  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.header = document.querySelector('header');
      this.initializeProperties();
      this.initMenu();
      this.initSwiper();
      window.addEventListener('resize', this.handleScroll);
      window.addEventListener('scroll', this.handleScroll);
    });
  }

  // InitializeProperties
  private initializeProperties() {
    this.menuItems =
      document.querySelectorAll<HTMLAnchorElement>('.has-submenu > a');
    this.backButton = document.getElementById('back');
    this.closeButton = document.getElementById('close');
    this.overlay = document.getElementById('overlay');
    this.submenus = document.querySelectorAll<HTMLElement>(
      '.header-primary__submenu'
    );
    this.primaryLinks = document.querySelectorAll<HTMLElement>(
      '.header-primary__menu-item.link'
    );
    this.primaryMenu = document.querySelectorAll<HTMLElement>(
      '.header-primary__menu-item'
    );
    this.linksMobile = document.querySelectorAll<HTMLElement>(
      '.header-primary__menu-item.mobile'
    );
  }

  // InitMenu
  private openSubmenu(submenu: HTMLElement) {
    this.closeAllSubmenus();
    this.primaryLinks.forEach((link) => {
      link.style.display = 'none';
    });

    if (this.primaryMenu) {
      this.primaryMenu.forEach((link) => {
        link.style.display = 'none';
      });
    }

    submenu.style.display = 'flex';
    if (submenu.parentElement) {
      submenu.parentElement.style.display = 'flex';
    }
    if (this.backButton) this.backButton.style.display = 'flex';
    if (this.closeButton) this.closeButton.style.display = 'none';
    if (this.linksMobile) {
      this.linksMobile.forEach((link) => {
        link.style.display = 'none';
      });
    }
  }

  private resetMenu() {
    this.closeAllSubmenus();

    this.primaryLinks.forEach((link) => {
      link.style.display = 'flex';
    });

    if (this.backButton) this.backButton.style.display = 'none';
    if (window.innerWidth >= 1024 && this.closeButton) {
      this.closeButton.style.display = 'block';
    }
  }

  private closeAllSubmenus() {
    this.submenus.forEach((submenu) => {
      submenu.style.display = 'none';
    });
    console.log(window.innerWidth);
    if (this.linksMobile && window.innerWidth < 1024) {
      this.linksMobile.forEach((link) => {
        link.style.display = 'flex';
      });
    }
    if (this.primaryMenu) {
      this.primaryMenu.forEach((link) => {
        if (!link.classList.contains('mobile')) {
          link.style.display = 'flex';
        }
      });
    }
  }

  private initMenu() {
    this.menuItems.forEach((menuItem) => {
      menuItem.addEventListener('click', (event) => {
        event.preventDefault();
        const submenu = menuItem.nextElementSibling as HTMLElement | null;
        if (submenu) {
          this.openSubmenu(submenu);
        }
      });
    });

    this.backButton?.addEventListener('click', () => {
      this.resetMenu();
    });

    this.overlay?.addEventListener('click', () => {
      this.resetMenu();
    });
  }

  // InitSwiper
  private initSwiper() {

    new Swiper('.header-infos__swiper', {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      preventInteractionOnTransition: true
    });
  }

  // HandleScroll
  private handleScroll = () => {
    let scroll_point: number;
    if (window.innerWidth >= this.desktopWidth) {
      scroll_point = 40;
    } else {
      scroll_point = 52;
    }

    if (!this.header) {
      return;
    }

    if (window.scrollY >= scroll_point) {
      this.header.classList.add('scrolled');
    } else {
      this.header.classList.remove('scrolled');
    }

  }
}

// Instanciation de la classe
export const headerPrimaryMenu = new HeaderPrimaryMenu();
